import { Component } from '@angular/core';
import { faHandWave } from '@fortawesome/pro-solid-svg-icons';

import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-list-welcome-item',
  templateUrl: 'list-welcome-item.component.html',
  styleUrls: ['./list-welcome-item.component.scss', './_list-welcome-item-theme.component.scss']
})
export class ListWelcomeItemComponent {
  faHandWave = faHandWave;

  constructor(public surveyEditorService: SurveyEditorService) {}

  onActivate(): void {
    this.surveyEditorService.selectWelcomeScreen();
  }
}
